export default "__VITE_ASSET__26aed333__"